exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title-ts-detail[data-v-72b0b2dc] {\n  border-bottom: 0.005rem solid rgba(226, 230, 235, 0.85);\n  margin-left: -12px;\n  margin-right: -12px;\n}\n.date-title[data-v-72b0b2dc] {\n  font-weight: 500;\n  font-size: 1.265rem;\n  color: rgba(6, 38, 62, 0.74);\n}\n", ""]);

// exports
